import React from "react";
import "./BentoBox.css";

export default function BentoBox() {
    const scrollToFeatures = () => {
        const el = document.getElementsByClassName("cards-container")[0];
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <div className="bento-box-container">
            <div className="content-inner-container">
                <div className="bento-box-column-1">
                    <div className="box-1">
                        <div className="box-1-gradient"></div>
                        <div className="box-content-text">
                            <h1>%100 Guven</h1>
                            <div className="box-1-under-text">

                                <p>Binlerce sürücü Isparta Gezen <br /> Adam Ekspertiz’e güveniyor.</p>
                                <h2>Aracınız Emin Ellerde</h2>
                            </div>
                        </div>
                    </div>
                    <div className="box-2">
                        <div className="circleB c1"></div>
                        <div className="circleB c2"></div>
                        <div className="circleB c3"></div>
                        <div className="box-2-gradient"></div>

                        <div className="box-content-text2">
                            <div className="img-container">
                                <img id="star-img" src={require("/Users/oguzhanozkan/Desktop/Isparta Gezen Adam/isparta-gezen-adam/src/Assets/star.png")} alt="" />
                            </div>
                            <div className="box-2-under-text">

                                <h2>10.000+ Mutlu Müşteri</h2>
                                <h2>Her marka ve model için güvenilir analiz.</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bento-box-column-2">
                    <div className="box-3">
                        <div className="box-3-gradient"></div>
                        <h1>Detaylı Rapor</h1>
                    </div>
                    <div className="box-4">
                        <div className="box-4-gradient-left"></div>
                        <div className="box-4-img-container">
                            <img className="bento-car" src={require("/Users/oguzhanozkan/Desktop/Isparta Gezen Adam/isparta-gezen-adam/src/Assets/bento-car.png")} alt="" />
                        </div>
                        <div className="box-4-gradient-right"></div>
                    </div>
                </div>
                <div className="bento-box-column-3">
                    <div className="box-5">
                        <div className="box-5-content">
                            <div className="box-5-text-top">

                                <h1>Isparta Ekspertiz <span className="dash">>></span></h1>
                            </div>
                            <div className="box-5-content-bottom">
                                <p>Aracınızın motorundan <br /> frenine kadar tüm <br /> kontrolleri tek noktada.</p>
                                <button className="call-btn transparentb">
                                    <a href="tel:+905013341032">Bizi Arayın</a>
                                </button>
                            </div>
                        </div>

                    </div>
                    <div className="box-6">
                        <div className="box-6-gradient"></div>
                        <div className="box-6-container">
                            <div className="box-6-top-text">
                                <h1>Ekspertiz Fiyatlarımızı Keşfedin</h1>

                            </div>
                            <div className="box-6-cards">
                                <div className="box-6-card-left"></div>
                                <div className="box-6-card-middle"></div>
                                <div className="box-6-card-right"></div>
                            </div>
                            <div className="box-6-bottom-button">
                                <button onClick={scrollToFeatures} className="packages-btn">Paketlerimiz</button>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
}